import { render, staticRenderFns } from "./MerchantReturns.vue?vue&type=template&id=477ddaa0&scoped=true"
import script from "./MerchantReturns.vue?vue&type=script&lang=js"
export * from "./MerchantReturns.vue?vue&type=script&lang=js"
import style0 from "./MerchantReturns.vue?vue&type=style&index=0&id=477ddaa0&prod&scoped=true&lang=css"
import style1 from "./MerchantReturns.vue?vue&type=style&index=1&id=477ddaa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477ddaa0",
  null
  
)

export default component.exports